import { Component, ChangeDetectionStrategy, OnInit, ElementRef, OnDestroy, inject, viewChild } from '@angular/core';

import { mainNavigationConfig } from '../config/navigation.config';
import { NavigationModel } from '@shared/models/navigation';
import { PrivilegesService } from '@app/privileges';
import { BehaviorSubject, fromEvent, Subscription } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import { NavItemComponent } from '../components/item-nav/item-nav.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-side-navigation',
    templateUrl: './side-navigation.component.html',
    styleUrls: ['./side-navigation.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NavItemComponent, AsyncPipe],
})
export class SideNavigationComponent implements OnInit, OnDestroy {
    private privilegesService = inject(PrivilegesService);

    el = viewChild.required<ElementRef<HTMLElement>>('sidebar');
    scrolling$ = new BehaviorSubject<boolean>(false);

    navigation: NavigationModel[];

    private subscriptions$ = new Subscription();

    ngOnInit(): void {
        const nav = [...mainNavigationConfig].map((item) => ({ ...item }));

        this.navigation = nav
            .filter((item) => {
                if (item.enabled) {
                    if (item.children) {
                        item.children = item.children.filter((childItem) => {
                            if (childItem.enabled) {
                                return childItem.role ? this.privilegesService.hasPermission(childItem.role) : true;
                            }
                        });
                        if (item.children.length === 0 && item.needsChildren === true) {
                            return false;
                        }
                    }
                    return item.role ? this.privilegesService.hasPermission(item.role) : true;
                }
            })
            .map((item) => {
                if (item.children && item.children.length === 1) {
                    return { ...item.children[0], icon: item.children[0].icon ?? item.icon, title: item.title };
                }
                return item;
            });

        this.subscriptions$.add(
            fromEvent(this.el().nativeElement, 'scroll')
                .pipe(
                    tap(() => {
                        if (this.scrolling$.value === false) {
                            this.scrolling$.next(true);
                        }
                    }),
                    debounceTime(200),
                    tap(() => this.scrolling$.next(false)),
                )
                .subscribe(),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions$.unsubscribe();
    }
}
